import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

import List from './List2';

export default {
  list: List,
  icon: AccountBalanceIcon,
};
